import moment from 'moment';

let offset = moment().utcOffset();

export const TimezoneMiddleware = {
  get offset() {
    return offset;
  },

  setOffset(value: number) {
    offset = value;
  },

  getHeader(): Record<string, string> {
    return { 'UTC-Offset': String(offset) };
  },
};
